module.exports = __webpack_public_path__ + "static/media/logo.44786b9f.png";